import Dagre from "@dagrejs/dagre";
import { AppEdge } from "features/entities/EntityCreatePage/EntityGraph/edges/types";
import { useAddDraftNode } from "features/entities/EntityCreatePage/EntityGraph/hooks/useAddDraftNode";
import { useFitViewWithDelay } from "features/entities/EntityCreatePage/EntityGraph/hooks/useFitViewWithDelay";
import { AppNode } from "features/entities/EntityCreatePage/EntityGraph/nodes/types";
import { useEffect, useRef } from "react";

export const getLayoutedElements = (nodes: AppNode[], edges: AppEdge[]) => {
  const g = new Dagre.graphlib.Graph().setDefaultEdgeLabel(() => ({}));
  g.setGraph({ rankdir: "TB", ranksep: 200 });

  edges.forEach((edge) => g.setEdge(edge.source, edge.target));
  nodes.forEach((node) =>
    g.setNode(node.id, {
      ...node,
      width: node.measured?.width ?? 0,
      height: node.measured?.height ?? 0,
    }),
  );

  Dagre.layout(g);

  return {
    nodes: nodes.map((node) => {
      const position = g.node(node.id);
      const x = position.x - (node.measured?.width ?? 0) / 2;
      const y = position.y - (node.measured?.height ?? 0) / 2;

      return { ...node, position: { x, y } };
    }),
    edges,
  };
};

export const useGraphInitLayout = (
  nodes: AppNode[],
  edges: AppEdge[],
  setEdges: (edges: AppEdge[]) => void,
  setNodes: (nodes: AppNode[]) => void,
) => {
  const layoutCount = useRef(0);
  const fitViewWithDelay = useFitViewWithDelay();

  useEffect(() => {
    // TODO ENG-8460 remove this hack
    if (layoutCount.current > 2) {
      return;
    }
    const res = getLayoutedElements(nodes, edges);
    setNodes(res.nodes);
    setEdges(res.edges);
    layoutCount.current += 1;
    fitViewWithDelay();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [nodes, edges]);
  const isLayouted = layoutCount.current > 2;

  const addDraftNode = useAddDraftNode();
  useEffect(() => {
    if (isLayouted) {
      addDraftNode();
    }
  }, [isLayouted, addDraftNode]);
};
